interface MenuItemChildrenConfig {
    component: React.ComponentType<{ currentSubmenu: unknown, onClose: () => void }>
    props?: Record<string, unknown>
}

interface MenuItem {
    id: string
    label: string
    icon?: React.ReactNode
    children?: React.ReactNode | MenuItemChildrenConfig
    props?: Record<string, any>
}

export interface L2RMenuWithChildrenProps {
    anchorEl: Element | null
    open: boolean
    onClose: (confirmed: boolean) => void
    menuConfig: Array<MenuItem>
}

export const isChildrenConfig = (v: unknown): v is MenuItemChildrenConfig =>
    typeof v === 'object' && v !== null && 'component' in v